export const STORYBLOK_ERROR_MESSAGE = 'StoryBlok error';
